import CircularProgress from "@material-ui/core/CircularProgress";
import { DataGrid, GridOverlay } from "@material-ui/data-grid";

import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import React from "react";
import "./style.scss";
import Loader from "components/loader/Loader";

// import { DataGridPro } from "@mui/x-data-grid-pro/index-cjs";
// import { LicenseInfo, DataGridPro } from "@mui/x-data-grid-pro/index-cjs";
// LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE);

const MyTable = ({
  rowHeight,
  rows,
  columns,
  pageSize,
  checkboxSelection,
  disableSelectionOnClick,
  CustomNoRowsOverlay,
  loading,
  className,
  onClickEvent,
  onSelectionModelChange,
  selectionModel,
  componentsProps,
  searchBar,
  QuickSearchToolbar,
  onPageChange,
  getRowId,
  ...rest
}) => {
  console.log('rows', rows,"columns",columns)
  function CustomLoadingOverlay() {
    return (
      <GridOverlay>
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      </GridOverlay>
    );
  }
  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: 5,
    width: 24,
    height: 24,
    backgroundColor: "#E7E7EB",
    "input:disabled ~ &": {
      boxShadow: "none",
    },
  }));

  // function BpCheckbox(props) {
  //   return (
  //     <div
  //       style={{ marginLeft: 10 }}
  //       sx={{
  //         "&:hover": { bgcolor: "transparent" },
  //       }}
  //       disableRipple
  //       color="default"
  //       // checkedIcon={<BpCheckedIcon />}
  //       icon={<BpIcon />}
  //       inputProps={{ "aria-label": "Checkbox demo" }}
  //       {...props}
  //     />
  //   );
  // }
  return (
    <>
      <DataGrid
        loading={loading}
        components={{
          LoadingOverlay: CustomLoadingOverlay,
          NoRowsOverlay: CustomNoRowsOverlay,
          Toolbar: searchBar,
          // Checkbox: BpCheckbox,
        }}
        className={`${className} data-table table-custom`}
        rows={rows}
        rowHeight={rowHeight}
        columns={columns}
        pageSize={pageSize}
        onCellClick={onClickEvent}
        // checkboxSelection={checkboxSelection}
        disableSelectionOnClick={disableSelectionOnClick}
        selectionModel={selectionModel}
        onSelectionModelChange={onSelectionModelChange}
        componentsProps={componentsProps}
        onPageChange={onPageChange}
        hideFooterSelectedRowCount
        getRowId={(row) => row._id}
        {...rest}
      />
    </>
  );
};

export default MyTable;
